import { Link } from "react-router-dom";
import { ScrollReveal } from "@/components/base/ScrollAnimations";
import { innovationPathway } from "@/mocks/homeData";

const stepRoutes: Record<string, string> = {
  PIIC: "/piic",
  PTIM: "/ptim",
  "Implementation & Scale-up": "/wings/innovation",
  Sustain: "/wings/innovation",
};

export default function InnovationPathway() {
  return (
    <section className="bg-tie-navy py-16 md:py-24 lg:py-32">
      <div className="w-full px-4 md:px-8 lg:px-12">
        {/* Header */}
        <ScrollReveal>
          <div className="text-center max-w-3xl mx-auto mb-10 md:mb-16">
            <div className="inline-flex items-center gap-2 px-3 py-1.5 rounded-md bg-tie-teal/20 mb-4 md:mb-6">
              <span className="text-xs font-semibold text-tie-teal-light uppercase tracking-wider">
                / Innovation Pathway
              </span>
            </div>
            <h2 className="font-serif text-2xl md:text-3xl lg:text-5xl font-bold text-white leading-tight">
              From Circle to Scale
            </h2>
            <p className="mt-3 md:mt-4 text-base md:text-lg text-white/60">
              TIE's innovation pathway transforms factory-level ideas into
              institutionalized capabilities through a structured, evidence-based
              journey.
            </p>
          </div>
        </ScrollReveal>

        {/* Pathway Steps */}
        <div className="relative max-w-6xl mx-auto">
          {/* Connector Line - Desktop */}
          <div className="hidden lg:block absolute top-[60px] left-[12.5%] right-[12.5%] h-0.5 bg-tie-teal/30" />

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 md:gap-8">
            {innovationPathway.map((step, index) => {
              const route = stepRoutes[step.step];
              const StepCard = (
                <div className="relative">
                  {/* Step Number */}
                  <div className="flex items-center gap-3 mb-4 md:mb-5">
                    <div className="w-12 h-12 md:w-14 md:h-14 rounded-full bg-tie-teal/20 border-2 border-tie-teal flex items-center justify-center shrink-0">
                      <span className="font-serif text-lg md:text-xl font-bold text-tie-teal-light">
                        {index + 1}
                      </span>
                    </div>
                    <div className="lg:hidden flex-1 h-0.5 bg-tie-teal/20" />
                  </div>

                  {/* Content */}
                  <div className={`p-5 md:p-6 rounded-xl bg-white/5 border border-white/10 hover:bg-white/10 hover:border-tie-teal/30 transition-all duration-300 ${route ? "cursor-pointer" : ""}`}>
                    <div className="flex items-center justify-between mb-3">
                      <span className="text-xs font-bold text-tie-teal uppercase tracking-wider">
                        {step.step}
                      </span>
                      <span className="text-xs text-white/40 px-2 py-1 rounded-full bg-white/5">
                        {step.duration}
                      </span>
                    </div>
                    <h3 className="text-base md:text-lg font-semibold text-white mb-2">
                      {step.title}
                    </h3>
                    <p className="text-sm text-white/60 leading-relaxed">
                      {step.description}
                    </p>
                    {route && (
                      <div className="mt-3 pt-3 border-t border-white/10">
                        <span className="inline-flex items-center text-sm font-medium text-tie-teal-light">
                          Learn more
                          <i className="ri-arrow-right-line ml-1.5 text-xs" />
                        </span>
                      </div>
                    )}
                  </div>
                </div>
              );

              return (
                <ScrollReveal key={step.step} delay={index * 150}>
                  {route ? (
                    <Link to={route} className="block">
                      {StepCard}
                    </Link>
                  ) : (
                    StepCard
                  )}
                </ScrollReveal>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
}